import React from "react";

/**
 * Render chemistry shorthand:
 *  - `H_2O` or `H_{2}O` → H₂O (subscript)
 *  - `Mg^2+` or `Mg^{2+}` → Mg²⁺ (superscript)
 *  - Combine: `Ca^{2+}_3(PO_4)_2`
 *
 * Falls back to plain text when no markers present.
 */
export function ChemText({ text, className = "" }) {
  if (!text) return null;
  const parts = [];
  let buffer = "";
  let i = 0;
  const flush = () => {
    if (buffer) {
      parts.push({ type: "text", value: buffer });
      buffer = "";
    }
  };
  while (i < text.length) {
    const ch = text[i];
    if (ch === "_" || ch === "^") {
      flush();
      const tag = ch === "_" ? "sub" : "sup";
      i++;
      let content = "";
      if (text[i] === "{") {
        i++;
        while (i < text.length && text[i] !== "}") {
          content += text[i++];
        }
        if (text[i] === "}") i++;
      } else if (i < text.length) {
        content = text[i++];
      }
      parts.push({ type: tag, value: content });
    } else {
      buffer += ch;
      i++;
    }
  }
  flush();
  return (
    <span className={className}>
      {parts.map((p, idx) => {
        if (p.type === "sub") return <sub key={idx}>{p.value}</sub>;
        if (p.type === "sup") return <sup key={idx}>{p.value}</sup>;
        return <React.Fragment key={idx}>{p.value}</React.Fragment>;
      })}
    </span>
  );
}
